declare global {
    interface Window {
        dataLayer: any[];
    }
}
export const trackSignUpStep = (step: string) => {
    console.log(`Trigger GA event: sign_up_step -> ${step}`)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: step,
    })
}
